/* eslint-disable @typescript-eslint/naming-convention */
export const PAGE_TYPE = {
  CarCompare: 'car_compare',
  Home: 'home',
  Plp: 'plp',
  Pdp: 'pdp',
  Guides: 'Guides',
  Review: 'review',
  ElectricCars: 'electric-cars',
  Favourites: 'favourites',
  UniversalPage: 'universal_page',
  Leasing: 'leasing',
  LeasingPlp: 'leasing_plp',
  ExclusiveOffers: 'exclusive_offers',
};

export type PageType = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE];
